export const serverIp = "https://sairahjewels.com";
// export const serverIp = "http://34.237.32.255:5000";
// export const serverIp = "http://127.0.0.1:5001";
// export const serverIp = "https://sairah-backend.onrender.com";
